.wrapper {
  width: 100%;
}

.wrapper--scrollable {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.table--with-dividers {
  .row--body {
    border-bottom: 1px solid var(--dds-color-border-subtle);
  }

  .row--colapsible-header--open {
    border-bottom: none;
  }
}

.table--sticky-header {
  tr th {
    position: sticky;
    top: 0;
    z-index: var(--dds-zindex-sticky);
  }
}

.table--with-stripes {
  .row--body {
    &:nth-of-type(even) {
      background-color: var(--dds-color-surface-subtle);
    }

    &:nth-of-type(odd) {
      background-color: var(--dds-color-surface-default);
    }
  }
}

.table--small {
  td,
  th {
    padding: var(--dds-spacing-x0-25) var(--dds-spacing-x0-5);
  }
  th {
    font: var(--dds-font-heading-xsmall);
    letter-spacing: var(--dds-font-heading-xsmall-letter-spacing);
    background-color: var(--dds-color-surface-default);
  }
}

.table--with-stripes.table--small {
  .row--body {
    &:nth-of-type(odd) {
      background-color: var(--dds-color-surface-subtle);
    }

    &:nth-of-type(even) {
      background-color: var(--dds-color-surface-default);
    }
  }
}

.table--medium {
  th {
    font: var(--dds-font-heading-small);
  }
  td,
  th {
    padding: var(--dds-spacing-x0-75);
  }
}

.table--large {
  th {
    font: var(--dds-font-heading-small);
  }
  td,
  th {
    padding: var(--dds-spacing-x1-5) var(--dds-spacing-x0-75);
  }
}

.row {
  @media (prefers-reduced-motion: no-preference) {
    transition:
      background-color var(--dds-motion-micro-state),
      border-color var(--dds-motion-micro-state),
      box-shadow var(--dds-motion-micro-state);
  }
}

.table {
  .row--body {
    background-color: var(--dds-color-surface-default);

    &.row--sum,
    &.row--sum:nth-of-type(even),
    &.row--sum:nth-of-type(odd) {
      border-bottom: 1px solid var(--dds-color-border-default);
      border-top: 1px solid var(--dds-color-border-default);
      background: var(--dds-color-surface-default);
    }

    &.row--selected,
    &.row--selected:nth-of-type(even),
    &.row--selected:nth-of-type(odd) {
      background-color: var(--dds-color-surface-selected-default);
    }

    &.row--hoverable:hover {
      background-color: var(--dds-color-surface-hover-default);
    }
  }
}

.cell--head {
  background-color: var(--dds-color-brand-primary-subtle);
  color: var(--dds-color-text-on-primary-subtle);
}

.cell--left {
  text-align: left;
}

.cell--right {
  text-align: right;
}

.cell--center {
  text-align: center;
}

.cell__inner {
  display: flex;
  align-items: center;
  gap: var(--dds-spacing-x0-75);
}

.sort-button {
  gap: var(--dds-spacing-x0-5);
  -webkit-user-select: text;
          user-select: text;
  display: flex;
  align-items: center;
  color: inherit;

  @media (prefers-reduced-motion: no-preference) {
    transition: var(--dds-focus-transition);
  }
}

.collapse-button {
  border-radius: var(--dds-border-radius-button);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;

  @media (prefers-reduced-motion: no-preference) {
    transition: all var(--dds-motion-micro-state);
  }

  &:hover {
    background-color: var(--dds-color-surface-hover-default);
  }
}
